import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { endpoints } from '../endpoints';
import { IContact } from '../models/contact';
import { ErrorService } from '../helpers/errorService';
import { ECorePlanningTeamType, EEopTemplates } from '../models/eop_types.enum';

@Injectable({
  providedIn: 'root'
})
export class ContactsService {
  constructor(
    private http: HttpClient,
    private errorService: ErrorService
  ) { }

  getContacts(buildingId: string): Observable<{has_error: boolean, message: string, data: IContact[]}> {
    const url = environment.apiBaseUrl + endpoints.contacts.replace(':buildingId', buildingId);
    return this.http.get<{has_error: boolean, message: string, data: IContact[]}>(url).pipe(
      catchError(this.errorService.handleError)
    );
  }

  // get contacts by buildingId
  getBuildingPlanningTeam(buildingId: string, eopTemplateId: EEopTemplates, teamTypeId?: ECorePlanningTeamType): Observable<{has_error: boolean, message: string, data: any[]}> {
    const url = environment.apiBaseUrl + endpoints.getBuildingDepartmentContacts.replace(':buildingId', buildingId).replace(':eopTemplateId', eopTemplateId.toString());
    let params = new HttpParams();
    if (teamTypeId) {
      params = params.set('team_type_id', teamTypeId);
    }
    return this.http.get<{has_error: boolean, message: string, data: any[]}>(url, { params }).pipe(
      catchError(this.errorService.handleError)
    );
  }

  saveBuildingCorePlanningTeam(buildingId: string, eopTemplateId: EEopTemplates, teamTypeId: string, contactData: any[]): Observable<{has_error: boolean, message: string, data: any}> {
    const url = environment.apiBaseUrl + endpoints.createBuildingCorePlanningTeam.replace(':buildingId', buildingId).replace(':eopTemplateId', eopTemplateId.toString()).replace(':corePlanningTeamTypeId', teamTypeId);
    return this.http.post<{has_error: boolean, message: string, data: any}>(url, contactData).pipe(
      catchError(this.errorService.handleError)
    );
  }

  deleteBuildingCorePlanningTeam(buildingId: string, eopTemplateId: EEopTemplates, teamTypeId: string): Observable<{has_error: boolean, message: string, data: any}> {
    const url = environment.apiBaseUrl + endpoints.deleteBuildingCorePlanningTeam.replace(':buildingId', buildingId).replace(':eopTemplateId', eopTemplateId.toString()).replace(':corePlanningTeamTypeId', teamTypeId);
    return this.http.delete<{has_error: boolean, message: string, data: any}>(url).pipe(
      catchError(this.errorService.handleError)
    );
  }

  approveBuildingCorePlanningTeam(buildingId: string, eopTemplateId: EEopTemplates, teamTypeId: string): Observable<{has_error: boolean, message: string, data: any}> {
    const url = environment.apiBaseUrl + endpoints.approveBuildingCorePlanningTeam.replace(':buildingId', buildingId).replace(':eopTemplateId', eopTemplateId.toString()).replace(':corePlanningTeamTypeId', teamTypeId);
    return this.http.post<{has_error: boolean, message: string, data: any}>(url, {}).pipe(
      catchError(this.errorService.handleError)
    );
  }

}